import User from '../../../models/User';

export enum AuthActionType {
    LOGIN,
    LOGOUT,
}

//actions
export type AuthAction = { type: AuthActionType.LOGIN; payload: User } | { type: AuthActionType.LOGOUT };
